import { css } from '@emotion/react'
import React from 'react'
import { UnitNumber } from '@/lib/number'
import { font } from 'plume-ui'

export const SummaryAmountWithCurrency: React.VFC<{
  amount: UnitNumber
  currency: string
}> = (props) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: baseline;
      `}
    >
      <div
        className="currency"
        css={css`
          display: inline-block;
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 16px;
          line-height: 100%;
          margin-right: 4px;
          vertical-align: bottom;
        `}
      >
        {props.currency}
      </div>
      <div
        className="value"
        css={css`
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 32px;
          line-height: 75%;
        `}
      >
        {props.amount.value?.toFixed(1) ?? '-'}
      </div>
      <div
        className="unit"
        css={css`
          display: inline-block;
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 16px;
          line-height: 100%;
          margin-left: 4px;
          vertical-align: bottom;
        `}
      >
        {props.amount.unit}
      </div>
    </div>
  )
}
